import { IS_SSR } from '@constants/ssr';
import { getDomain } from 'utils/domain-utils';

import { COOKIES, REFRESH_TOKEN_KEY } from '../constants';

export const saveLocalRefreshToken = (token: string, expiresIn: number): void => {
  COOKIES.set(REFRESH_TOKEN_KEY, token, {
    domain: getDomain(),
    path: '/',
    httpOnly: false,
    maxAge: expiresIn,
    sameSite: 'strict',
    secure: true,
  });
};

export const getLocalRefreshToken = (): string => {
  if (IS_SSR) {
    return '';
  }

  return COOKIES.get(REFRESH_TOKEN_KEY);
};

export const deleteLocalRefreshToken = (): void => {
  COOKIES.remove(REFRESH_TOKEN_KEY, {
    domain: getDomain(),
    path: '/',
  });
};
